import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { JobService } from '../services/job.service';
import { ChangeOrder } from '../../shared/models/change.order.interface';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { QuoteService } from '../../quote/services/quote.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LostReasonType } from '../../shared/models/lost.reason.type.interface';
import { Competitor } from '../../shared/models/competitor.interface';
import { QuoteArea } from '../../shared/models/quote.area.interface';
import { Area } from '../../shared/models/area.interface';
import { ContactSelect } from '../../quote/models/contact.select.interface';
import { Quote } from '../../shared/models/quote.interface';
import { MatDialog } from '@angular/material/dialog';
import { FileService } from '../../shared/services/file.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuoteCopyDialog, QuoteEmailDialog } from '../../shared/controls/quote/quote-details/quote-details.component';
import { ChangeOrderApproveDialog } from '../change-order-approve-dialog/change.order.approve.dialog';
import { QuoteAreaItem } from '../../shared/models/quote.area.item.interface';
import { ChangeOrderAreaSummary } from '../models/change.order.area.summary.interface';
import { ChangeOrderAreaDialog } from '../change-order-area-dialog/change.order.area.dialog';
import { ChangeOrderDialog, ChangeOrderDialogData } from '../change-order-dialog/change.order.dialog';
import { RolePermission } from '../../shared/models/role.permission.enum';
import { QuoteTaxOptionsDialog } from '../../shared/controls/quote/quote-tax-options/quote-tax-options.dialog';
import { ChangeOrderPrintDialog } from '../change-order-print-dialog/change.order.print.dialog';
import { CalculateService } from '../../shared/services/calculate.service';
import { DealerService } from '../../dealer/services/dealer.service';
import { ChangeOrderItemSummary } from '../models/change.order.item.summary';
import { ChangeOrderItem } from '../../shared/models/change.order.item.interface';
import { QuoteAcknowledgement } from '../../shared/models/quote.acknowledgement.interface';
import { QuoteItemNoteTemplate } from '../../shared/models/quote.item.note.template.interface';

export interface StatusDialogData {
  quote_ID: number;
  quote_IsLost: boolean;
  lostReasonType_ID: number;
  competitor_ID: number;
  quote_LostNote: string;

  lostReasonTypes: LostReasonType[];
  competitors: Competitor[];
}
export interface CopyDialogData {
  quote_ID: number;
  quoteCopy_Name: string;
}
export interface EmailDialogData {
  quote_ID: number;
  contacts: ContactSelect[];
  quoteEmail_Message: string;
  docuSignEnabled: boolean;
  sendWithSignatureBlock: boolean;
}

@Component({ template: '' })
export class ChangeOrderComponent extends AbstractBiditComponent {
  quote: Quote = {} as Quote;
  changeOrder: ChangeOrder = {} as ChangeOrder;
  changeOrderAcknowlegement: QuoteAcknowledgement = {} as QuoteAcknowledgement;

  areaSummaries: ChangeOrderAreaSummary[];
  areas: Area[];
  lostReasonTypes: LostReasonType[];
  competitors: Competitor[];
  quoteItemNoteTemplates: QuoteItemNoteTemplate[];


  changeOrderMarginAmount: number;
  changeOrderMargin: number;
  changeOrderTotalBidAmount: number;

  readOnly: boolean = true;
  canAddChangeOrder: boolean = false;
  initialLoad: boolean = null;
  allowAddEdit: boolean = false;

  showMarginEdit: boolean = false;
  canApprove: boolean = false;
  showBidAmountEdit: boolean = false;
  dealerRoundingType: number;
  showLinePricing: boolean = false;
  showCostBreakdown: boolean = false;
  showMargins: boolean = false;
  allowPrint: boolean = false;


  constructor(private dialog: MatDialog, private jobService: JobService, private fileService: FileService,
    private calculateService: CalculateService,
    private dealerService: DealerService, private quoteService: QuoteService,
    deviceDetectorService: DeviceDetectorService,
    private router: Router, private route: ActivatedRoute) {
    super(deviceDetectorService);
  }

  @Input()
  public set value(value: number) {
    if (value) {
      this.loadChangeOrder(value);
    }
  }

  @Output() updated = new EventEmitter<ChangeOrder>();
  @Output() toggleChangeOrderDisplay = new EventEmitter<number>();

  ngOnInit(): void {
    this.jobService.getAreas()
      .subscribe({
        next: (data) => {
          this.areas = data;
         
        },
        error: (error: string) => this.onError(error)
      });

    this.quoteService.getQuoteItemNoteTemplates()
      .subscribe({
        next: (data) => {
          this.quoteItemNoteTemplates = data;
        },
        error: (err) => this.onError(err)
      });

    this.readOnly = !JobService.hasPermission(RolePermission.EditChangeOrder);
    this.canAddChangeOrder = JobService.hasPermission(RolePermission.AddChangeOrder);
    this.showLinePricing = JobService.hasPermission(RolePermission.ShowLineItemPricing);
    this.showMargins = JobService.hasPermission(RolePermission.ViewEditMargins);
    this.showCostBreakdown = JobService.hasPermission(RolePermission.ShowCostBreakdown);
    this.allowPrint = JobService.hasPermission(RolePermission.ShowLineItemPricing) && QuoteService.hasPermission(RolePermission.ShowCostBreakdown) &&
      JobService.hasPermission(RolePermission.ViewEditMargins);
  }

  loadChangeOrder(changeOrderId: number) {
    this.jobService.getChangeOrderSummary(changeOrderId)
      .subscribe({
        next: (data) => {
          this.quote = data.quote;

          this.changeOrder = data.changeOrder;
          this.areaSummaries = data.areaSummaries;
          this.getDealerRoundingType();
          this.calculateQuote();

          var changeOrderAcknowlegements = this.quote.quoteAcknowledgements.filter(qa => qa.changeOrder_ID === changeOrderId).sort((a, b) => (a.quoteAcknowledgement_ID > b.quoteAcknowledgement_ID ? -1 : 1));
          this.changeOrderAcknowlegement = changeOrderAcknowlegements?.[0];

          if (this.changeOrderAcknowlegement !== undefined && ( this.changeOrderAcknowlegement?.acknowledgementStatusDesc == 'Accepted' || this.changeOrderAcknowlegement?.acknowledgementStatusDesc == 'Pending' && !this.changeOrderAcknowlegement?.isExpired)) {
            this.readOnly = true;
          }
          else {
            this.readOnly = !QuoteService.hasPermission(RolePermission.EditChangeOrder);

            if (this.canAddChangeOrder && (this.changeOrder.changeOrderItems.length === 0 || this.allowAddEdit)) {
              if (this.initialLoad === null) {
                this.allowAddEdit = true;
                this.initialLoad = false;
              }
              this.readOnly = false;
            }
          }

          this.canApprove = (this.changeOrderAcknowlegement === undefined || this.changeOrderAcknowlegement?.acknowledgementStatusDesc != 'Pending' || this.changeOrderAcknowlegement?.isExpired) && (QuoteService.hasPermission(RolePermission.EditChangeOrder) || this.allowAddEdit);
        },
        error: (error: string) => this.onError(error)
      });
  }

  getDealerRoundingType(): void {
    this.dealerService.getDealerDetails()
      .subscribe(result => {
        this.dealerRoundingType = result.dealer_Rounding;
      });
  }

  onAreaCanceled(quoteAreaParam: QuoteArea) {
    let area = this.areaSummaries.find(a => a.area_ID == quoteAreaParam.area_ID);
    let quoteArea = area.quoteAreas.find(qa => qa.quoteArea_ID == quoteAreaParam.quoteArea_ID);

    if (quoteArea) {
      quoteArea.showEdit = false;
    }
  }

  calculateQuote() {
    this.changeOrderMarginAmount = this.changeOrder.changeOrder_BidAmount - this.changeOrder.totalCost;
    this.changeOrderMargin = (100 - this.changeOrder.changeOrder_GrossMargin) / 100;
    this.changeOrderTotalBidAmount = this.changeOrder.changeOrder_BidAmount + this.changeOrder.netTax_Total;
  }

  openEditDialog() {
    let dialogData = {
      changeOrder: (<any>Object).assign({}, this.changeOrder)
    } as ChangeOrderDialogData;

    const dialogRef = this.dialog.open(ChangeOrderDialog, {
      width: '700px',
      data: dialogData,
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        console.log('The dialog was closed');
      if(result) {
        this.loadChangeOrder(this.changeOrder.changeOrder_ID);
      }
    }});
  }

  editMargin() {
    this.showMarginEdit = true;
  }

  editBid() {
    this.showBidAmountEdit = true;
  }

  updateQuoteMargin() {
    this.jobService.updateChangeOrderMargin(this.changeOrder.changeOrder_ID, this.changeOrder.changeOrder_GrossMargin)
      .subscribe({
        next: (data) => {
          this.changeOrder.changeOrder_BidAmount = data.changeOrder_BidAmount;

          this.calculateQuote();
          this.showMarginEdit = false;
        },
        error: (error: string) => this.onError(error)
      });
  }

  updateBidAmount() {
    this.changeOrder.changeOrder_BidAmount = this.calculateService.GetRoundedAmount(this.dealerRoundingType, this.changeOrder.changeOrder_BidAmount);

    this.jobService.updateChangeOrderBidAmount(this.changeOrder.changeOrder_ID, this.changeOrder.changeOrder_BidAmount)
      .subscribe({
        next: (data) => {
          this.changeOrder.changeOrder_GrossMargin = data.changeOrder_GrossMargin;
          this.changeOrder.changeOrder_BidAmount = data.changeOrder_BidAmount;

          this.calculateQuote();
          this.showBidAmountEdit = false;
        },
        error: (error: string) => this.onError(error)
      });
  }

  openTaxDialog(): void {
    const dialogRef = this.dialog.open(QuoteTaxOptionsDialog, {
      width: '900px',
      data: {
        quote_ID: this.quote.quote_ID,
        changeOrder_ID: this.changeOrder.changeOrder_ID,
        materialTax_Rate: this.changeOrder.materialTax_Rate ?? null,
        materialTax_Total: this.changeOrder.materialTax_Total ?? null,
        laborTax_Rate: this.changeOrder.laborTax_Rate ?? null,
        laborTax_Total: this.changeOrder.laborTax_Total ?? null,
        otherTax_Rate: this.changeOrder.otherTax_Rate ?? null,
        otherTax_Total: this.changeOrder.otherTax_Total ?? null,
        netTax_Total: this.changeOrder.netTax_Total ?? null,

        material_Cost: this.changeOrder.materialCost,
        labor_Cost: this.changeOrder.laborCost,
        other_Cost: this.changeOrder.otherCost
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The change order tax dialog was closed');
      if (result) {
        this.loadChangeOrder(this.changeOrder.changeOrder_ID);
      };
    });
  }

  printQuote(): void {
    const dialogRef = this.dialog.open(ChangeOrderPrintDialog, {
      data: {
        isInvoice: false
      }
    });
    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (!result) return;
        this.isRequesting = true;

        this.jobService.printChangeOrder(this.changeOrder.changeOrder_ID, result)
          .subscribe({
            next: (x) => {
              this.isRequesting = false;
              this.fileService.downloadFile(x, 'ChangeOrderContract.pdf');
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }

revertChangeOrder(changeOrderItemId: number): void {
  var proceed = confirm($localize`Undo this change?`);
  if(!proceed) return;

  this.jobService.deleteChangeOrderItem(changeOrderItemId)
    .subscribe({next:(result) => {
      this.loadChangeOrder(result);
    },
      error: (error: string) => this.onError(error)});
  }

deleteArea(acceptedItem: QuoteAreaItem): void {
  var proceed = confirm($localize`Delete this item?`);
  if(!proceed) return;

  this.jobService.removeQuoteArea(this.changeOrder.changeOrder_ID, acceptedItem.quoteArea_ID)
    .subscribe({
      next: (result) => {
      this.loadChangeOrder(result);
    },
      error: (error: string) => this.onError(error)});
  }

  openAreaDialog(quoteArea: QuoteArea, changeOrderItemId: number): void {
    const dialogRef = this.dialog.open(ChangeOrderAreaDialog, {
      width: '900px',
      data: {
        changeOrderId: this.changeOrder.changeOrder_ID,
        quoteAreaId: (quoteArea == null ? null : quoteArea?.quoteArea_ID),
        areas: this.areas,
        areaId: (quoteArea === null ? null : quoteArea?.area_ID),
        changeOrderItemId: changeOrderItemId === null ? null : changeOrderItemId,
        quoteItemNoteTemplates: this.quoteItemNoteTemplates
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        console.log('The area dialog was closed');
        if (result) {
          this.loadChangeOrder(this.changeOrder.changeOrder_ID);
        };
      }
    });
  }

  openEmailDialog(): void {

    var contacts = new Array() as ContactSelect[];
    if (this.quote.customer.contacts != null && this.quote.customer.contacts != undefined) {
      this.quote.customer.contacts.forEach((contact) => {

        if (contact.contact_Email && contact.contact_IsActive) {
          var cntct = contact as ContactSelect;
          if (contact.contact_ID == this.quote.customer.contact_ID) {
            cntct.signer = true;
          }
          contacts.push(contact as ContactSelect);
        }
      });
    }

    const dialogRef = this.dialog.open(QuoteEmailDialog, {
      width: (this.quote.dealer_DocusignEnabled ? '800px' : '500px'),
      data: {
        quote_ID: this.quote.quote_ID,
        changeOrder_ID: this.changeOrder.changeOrder_ID,
        contacts: contacts,
        docuSignEnabled: this.quote.dealer_DocusignEnabled,
        existingRequest: true,
        sendNewRequestBlock: true
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        this.loadChangeOrder(this.changeOrder.changeOrder_ID)
        this.updated.emit(this.changeOrder);
    }});
  }

  openCopyDialog(): void {
    const dialogRef = this.dialog.open(QuoteCopyDialog, {
      width: '500px',
      data: {
        quote_ID: this.quote.quote_ID
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        console.log('The dialog was closed');
        if (result) {
          this.jobService.copyChangeOrder(this.quote.quote_ID, result)
            .subscribe({
              next: (data) => {
                window.alert($localize`Change order copied`);
              },
              error: (error: string) => this.onError(error)
            });
        }
      }
    });
  }

  acknowledgeChangeOrder(status: number): void {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.jobService.acknowledgeChangeOrder(this.quote.quote_ID, this.changeOrder.changeOrder_ID, status)
      .subscribe({
        next: (result) => {
          this.loadChangeOrder(this.changeOrder.changeOrder_ID);
          this.updated.emit(this.changeOrder);
        },
        error: (err) => this.onError(err)
      });
  }

  approveChangeOrder(): void {
    let changeOrderCount = 0;
    this.areaSummaries.forEach((as) => {
      as.quoteAreas.forEach((qa) => {
        changeOrderCount += (qa.changeOrderItem == null ? 0 : 1);
      });

      changeOrderCount += as.newItems.length;
    });
    if (changeOrderCount == 0) {
      alert($localize`Cannot approve - No changes are assigned to this change order.`);
      return;
    }

    const dialogRef = this.dialog.open(ChangeOrderApproveDialog, {
      maxWidth: '95vw',
      panelClass: 'custom-dialog-container',
      data: {
        changeOrderId: this.changeOrder.changeOrder_ID
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        console.log('The dialog was closed');
        if (result) {
          this.updated.emit(this.changeOrder);
          this.toggleChangeOrderDisplay.emit(this.quote.quote_ID);
        }
      }
    });
  }

  returnToList() {
    this.toggleChangeOrderDisplay.emit(this.quote.quote_ID);
  }

}
